import _ from 'underscore';

export const getEmptyRecommendationsContext = finalUrl => ({
  finalUrl,
  themes: [],
});

export class SuggestionsTracker {
  constructor() {
    this.trackingData = {};
  }

  add(finalUrl, suggestions, suggestionsReport) {
    this.trackingData = this.trackingData || {};
    this.trackingData.finalUrl = finalUrl;
    this.trackingData.allTextSuggestions = this.trackingData.allTextSuggestions || {
      themes: [],
    };

    if (suggestions) {
      this.trackingData.allTextSuggestions = {
        themes: _.uniq((this.trackingData.allTextSuggestions.themes).concat(suggestions.themes)),
      };
    }
    if (_.isArray(suggestionsReport.view)) {
      this.trackingData.view = _.uniq((this.trackingData.view || []).concat(suggestionsReport.view));
    }
    if (_.isArray(suggestionsReport.apply)) {
      this.trackingData.apply = _.uniq((this.trackingData.apply || []).concat(suggestionsReport.apply));
    }
    if (_.isArray(suggestionsReport.returned)) {
      this.trackingData.returned = _.uniq((this.trackingData.returned || []).concat(suggestionsReport.returned));
    }
  }
}
